export enum ContactInfoFormFields {
	companyBranchAddress = 'companyBranchAddress',
	branchProvince = 'branchProvince',
	branchZip = 'branchZip',
	branchLocation = 'branchLocation',
	branchTelephone = 'branchTelephone',
	email = 'email',
	website = 'website',
	accountManager = 'accountManager',
}
